// api.js
import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://api.wbball.com', // 正式服务器
    // baseURL: 'https://test.oneg.vip', // 测试服务器
    timeout: 5000,
});

export function request(config) {
    return new Promise((resolve, reject) => {
        instance(config)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}
